import * as R from 'ramda';
export function flattenSchemaProps(schema, path = []) {
    return R.pipe(R.propOr({}, 'properties'), R.toPairs, R.map(R.adjust(0, R.append(R.__, path))), R.reduce((acc, cur) => {
        const [curPath, curSchema] = cur;
        if (!curSchema.properties) {
            return [...acc, cur];
        }
        const children = flattenSchemaProps(curSchema, curPath);
        return [...acc, cur, ...children];
    }, []), R.sortBy(R.pipe(R.head, R.join(''), R.toLower)))(schema);
}
export const flattenSchemaProps__legacy = R.curry((path, schema) => R.compose(R.sortBy(R.o(R.toLower, R.head)), R.splitEvery(2), R.flatten, R.converge(R.concat, [
    R.o(R.map(R.adjust(0, R.concat(path))), R.toPairs),
    R.compose(R.map(R.converge(flattenSchemaProps__legacy, [
        R.compose(R.concat(R.__, '.'), R.concat(path), R.head),
        R.last,
    ])), R.toPairs),
]), R.propOr({}, 'properties'))(schema));
